import { dataFileAddSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFileAddSolid = /*#__PURE__*/createIcon(dataFileAddSolid)
export default IconFileAddSolid
